<template>
    <div class="container">
        <div class="head_bg" :class="{'head_bg_img_1':cat==1,'head_bg_img_2':cat==2,'head_bg_img_3':cat==3,'head_bg_img_4':cat==4,'head_bg_img_5':cat==5,}">
            <common-head></common-head>
            <div class="head_content">
                <div>
                    <p>{{cat==1?'公司新闻':cat==2?'员工天地':cat==3?'人人有爱':cat==4?'公益助学':cat==5?'学习园地':''}}</p>
                    <div></div>
                </div>
            </div>
        </div>
        <div class="bg_c_g">
            <div class="content">
                <div class="card_list">
                    <card v-for="(item,index) in news_lsit" :item="item" :key="index" :index="index"></card>
                </div>
                <div class="more" v-show="Page!=totalPage" @click="handleMore">
                    点击加载更多
                </div>
                <div class="more" v-show="Page==totalPage">
                    当前已是最后一页
                </div>
            </div>

        </div>
        <common-footer></common-footer>
    </div>
</template>

<script>
import commonHead from '../components/common-head.vue'
import commonFooter from '../components/common-footer.vue'
import card from '../components/card.vue'
export default {
    data() {
        return {
            cat: 1,
            Page: 1,
            pageSize: 50,
            totalPage: null,
            news_lsit: [],
        }
    },
    components: {
        commonHead,
        commonFooter,
        card
    },
    created() {
        const { handleWatchRouter } = this
        handleWatchRouter()
    },
    watch: {
        "$route"() {
            const { handleWatchRouter } = this
            handleWatchRouter()
        }
    },
    methods: {
        handleWatchRouter() {
            const { getList } = this
            this.news_lsit = []
            this.Page = 1
            this.pageSize = 50
            this.totalPage = null
            this.cat = this.$route.params.cat || this.$route.query.cat
            getList()
        },
        getList() {
            const { news_lsit } = this
            this.$toast.loading({
                mask: true,
                message: '加载中...'
            });
            this.$http
                .get("site/news", {
                    params: {
                        cat: this.cat,
                        Page: this.Page,
                        Pagesize: this.pageSize
                    }
                })
                .then(response => {
                    this.$toast.clear();
                    this.news_lsit = news_lsit.length > 0 ? news_lsit.concat(response.d.Results) : response.d.Results;
                    this.Page = response.d.Page
                    this.totalPage = response.d.TotalPage;
                });
        },
        handleMore() {
            const { Page, totalPage, getList } = this
            if (Page < totalPage) {
                this.Page = Page + 1;
                getList();
            } else {
                this.$toast('已加载至最后一页');
            }
        }
    }
}
</script>

<style lang="less" scoped>
.head_bg_img_1 {
    background-image: url("../assets/images/banner_new.png");
}
.head_bg_img_2 {
    background-image: url("../assets/images/banner_new_ygtd.png");
}
.head_bg_img_3 {
    background-image: url("../assets/images/banner_mlh_rrya.png");
}
.head_bg_img_4 {
    background-image: url("../assets/images/banner_mlh_gyzx.png");
}
.head_bg_img_5 {
    background-image: url("../assets/images/banner_mxy_xxtd.png");
}
.head_bg {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    & .head_content {
        height: 95px;
        position: relative;
        & > div {
            position: absolute;
            top: 41px;
            left: 20px;
            & > p {
                font-size: 20px;
                color: #ffffff;
                margin-bottom: 3.5px;
            }
            & > div {
                width: 40px;
                height: 2px;
                background-color: #fff;
            }
        }
    }
}
.content {
    padding: 20px 20px 47.5px 20px;
    & .card_list {
        display: flex;
        flex-wrap: wrap;
        min-height:400px;
    }
    & .more {
        width: 100%;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #ffffff;
        font-size: 14px;
        color: #666666;
        letter-spacing: 0;
    }
}
</style>